import { Brain, Bot, Headphones, PieChart, Search, Cog } from "lucide-react";

const AI = () => {
  return (
    <section id="ai" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row-reverse items-center">
          <div className="md:w-1/2 mb-10 md:mb-0 md:pl-10">
            <h2 className="text-3xl font-bold mb-6">Artificial Intelligence</h2>
            <p className="text-lg text-gray-600 mb-6">
              Deploy cutting-edge AI solutions that transform business operations, enhance 
              customer experiences, and drive intelligent decision-making.
            </p>
            
            <div className="space-y-6">
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="flex items-start">
                  <div className="bg-purple-600/10 p-2 rounded-full mr-4">
                    <Brain className="h-5 w-5 text-purple-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-xl mb-2">RAG Framework</h3>
                    <p className="text-gray-600">
                      Retrieval-Augmented Generation combines large language models with your 
                      proprietary data to deliver more accurate, context-aware AI responses.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="flex items-start">
                  <div className="bg-purple-600/10 p-2 rounded-full mr-4">
                    <Bot className="h-5 w-5 text-purple-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-xl mb-2">Agentic AI</h3>
                    <p className="text-gray-600">
                      Autonomous AI agents that can perform complex tasks, reason through problems, 
                      and adapt to changing business contexts.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="grid grid-cols-2 gap-4">
                  <div className="text-center p-4 bg-white rounded-lg shadow-sm">
                    <Headphones className="h-6 w-6 text-purple-600 mx-auto mb-2" />
                    <h4 className="font-medium">Customer Care</h4>
                  </div>
                  <div className="text-center p-4 bg-white rounded-lg shadow-sm">
                    <PieChart className="h-6 w-6 text-purple-600 mx-auto mb-2" />
                    <h4 className="font-medium">BI Insights</h4>
                  </div>
                  <div className="text-center p-4 bg-white rounded-lg shadow-sm">
                    <Search className="h-6 w-6 text-purple-600 mx-auto mb-2" />
                    <h4 className="font-medium">Market Intelligence</h4>
                  </div>
                  <div className="text-center p-4 bg-white rounded-lg shadow-sm">
                    <Cog className="h-6 w-6 text-purple-600 mx-auto mb-2" />
                    <h4 className="font-medium">Process Automation</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="md:w-1/2">
            <img 
              src="https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600" 
              alt="AI and machine learning concept" 
              className="rounded-lg shadow-lg" 
              width="800" 
              height="600"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AI;
